import { useFirestoreGeneralArrayContains, useFirestoreOrderBy } from '../../firebase/useFirestore'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { db } from '../../firebase/config'
import { useEffect, useState } from 'react'
import plusButton from '../../images/icons/plus-icon.png'
import Modal from 'react-modal';
import CommonModal from '../common/Modal';
import firebase from '../../firebase/compat'
import Table from '../common/table/Table.jsx';
import TableCell from '../common/table/TableCell.jsx';
import ReadOnlyGuard from '../common/ReadOnlyGuard';
import DeleteModal from '../common/DeleteModal';
import softDeleteDoc from '../../helpers/softDeleteDoc';
import clickableRowProps from '../../helpers/a11y/clickableRowProps';

const LiveReportMedia = ({parent}) => {
    // State
    const [showAddContainer, setShowAddContainer] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [itemToDelete, setItemToDelete] = useState('')
    const [openModal, setOpenModal] = useState(false)
    const [addType, setAddType] = useState('media')
    const [storytellingItems, setStorytellingItems] = useState([])
    const [selectedMedia, setSelectedMedia] = useState([])

    // Hooks
    Modal.setAppElement('#root');
    const modalStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
      },
    };

    // Firestore
    const allMedia = useFirestoreOrderBy('LiveReportMedia', 'Position', 'asc')
    const allQuotes = useFirestoreOrderBy('Quotes', 'Position', 'asc')
    const allAnecdotes = useFirestoreOrderBy('Anecdotes', 'Position', 'asc')
    const media = useFirestoreGeneralArrayContains('LiveReportMedia', 'Parent', parent.ID)
    const anecdotes = useFirestoreGeneralArrayContains('Anecdotes', 'Parent', parent.ID)
    const quotes = useFirestoreGeneralArrayContains('Quotes', 'Parent', parent.ID)

    // Display item
    const displayItem = (item) => {

        switch (item.Type) {
            case 'image/jpeg':
                return <img src={item.Media} alt="" style={{width: '100px'}}/>
            case 'image/png':
                return <img src={item.Media} alt="" style={{width: '100px'}}/>
            case 'video':
                return <video src={item.Media} alt="" style={{width: '100px'}}/>
            case 'Quote':
                return <p>{item.Quote}</p>
            case 'Anecdote':
                return <p>{item.Anecdote}</p>
            default:
                return <p>Onbekend</p>
        }
    }

    // Media type
    const mediaType = (type) => {
        switch (type) {
            case 'image/jpeg':
                return 'Afbeelding'
            case 'image/png':
                return 'Afbeelding'
            case 'video':
                return 'Video'
            case 'Quote':
                return 'Quote'
            case 'Anecdote':
                return 'Anekdote'
            default:
                return 'Onbekend'
        }
    }

    // Create an array of all the storyytelling items
    const arrayOfStorytellingItems = () => {
        const array = []

        media && media.forEach(item => {
            array.push({
                Media: item.Media,
                Type: item.Type,
                docid: item.docid
            })
        })

        anecdotes && anecdotes.forEach(item => {
            array.push({
                Anecdote: item.Anecdote,
                Type: item.Type,
                docid: item.docid
            })
        })

        quotes && quotes.forEach(item => {
            array.push({
                Quote: item.Quote,
                Type: item.Type,
                docid: item.docid
            })
        })

        setStorytellingItems(array)
    }

    useEffect(() => {
        arrayOfStorytellingItems()
    }, [media, anecdotes, quotes])

    // Delete storytelling item
    // Eerst bevestigen: één klik verwijderde het item meteen en onherstelbaar.
    const askDeleteStorytelling = (e) => {
        const docid = e.target.getAttribute('data-docid')
        if (!docid) return
        setItemToDelete(docid)
        setDeleteModal(true)
    }

    // Het item zit maar in één van de drie collecties; welke is hier niet
    // bekend, dus alle drie worden gemarkeerd. Een markering op een document
    // dat niet bestaat doet niets. Zacht verwijderen (ADR-008): de hooks
    // filteren verwijderde documenten centraal weg.
    const deleteStorytelling = async () => {
        if (!itemToDelete) return
        await Promise.all(
            ['LiveReportMedia', 'Anecdotes', 'Quotes'].map((collection) =>
                softDeleteDoc({ collection, docid: itemToDelete }).catch(() => null)
            )
        )
    }

    // Add storytelling item
    const addStorytelling = () => {

        if (addType === 'media') {
            selectedMedia.forEach(item => {
                db.collection('LiveReportMedia')
                .doc(item.docid)
                .update({
                    Parent: firebase.firestore.FieldValue.arrayUnion(parent.ID),
                })
            })
        }

        if (addType === 'quote') {
            selectedMedia.forEach(item => {
                db.collection('Quotes')
                .doc(item.docid)
                .update({
                    Parent: firebase.firestore.FieldValue.arrayUnion(parent.ID),
                })
            })
        }

        if (addType === 'anecdote') {
            selectedMedia.forEach(item => {
                db.collection('Anecdotes')
                .doc(item.docid)
                .update({
                    Parent: firebase.firestore.FieldValue.arrayUnion(parent.ID),
                })
            })
        }

        setOpenModal(false)
    }

    // Adding type
    const addingType = () => {
        switch (addType) {
            case 'media':
                return 'media'
            case 'quote':
                return 'quote'
            case 'anecdote':
                return 'anekdote'
            default:
                return 'Onbekend'
        }
    }

   // Select media items
    const selectMediaItems = (e) => {
        const docid = e.target.dataset.docid;
        const url = e.target.dataset.url || '';
        const quote = e.target.dataset.quote || '';
        const anecdote = e.target.dataset.anecdote || '';

        // Check if the item is already in selected media
        if (selectedMedia.some(item => item.docid === docid)) {
            // Remove item if already selected
            const newMedia = selectedMedia.filter(item => item.docid !== docid);
            setSelectedMedia(newMedia);
        } else {
            // Add new item with both id and url
            setSelectedMedia([...selectedMedia, { docid, url, quote, anecdote }]);
        }
    };

  return (
    <ReadOnlyGuard edit="reports.edit">
      {(canEdit) => (
        <div id='live-report-media-container'>
        <p><b>Voeg storytelling toe</b></p>
        <Table
            columns={[
                { key: 'storytelling', label: 'STORYTELLING' },
                { key: 'type', label: 'TYPE', searchable: false },
                { key: 'delete', label: 'VERWIJDEREN', searchable: false },
            ]}
            items={storytellingItems || []}
            getItemKey={(item, index) => item.docid || `${item.Type}-${index}`}
            renderRow={(item) => (
                <>
                    <TableCell>
                        {displayItem(item)}
                    </TableCell>
                    <TableCell>
                        <p>{mediaType(item.Type)}</p>
                    </TableCell>
                    <TableCell>
                        {canEdit && (
                            <DeleteOutlinedIcon className='table-delete-icon' data-docid={item.docid} onClick={askDeleteStorytelling}/>
                        )}
                    </TableCell>
                </>
            )}
            searchAccessor={(item) => item?.Quote || item?.Anecdote || mediaType(item?.Type)}
            searchPlaceholder="Zoeken op storytelling"
            emptyMessage="Geen storytelling gevonden."
            addRow={canEdit ? {
                toolTipContent: 'Storytelling toevoegen',
                onClick: () => setShowAddContainer(!showAddContainer),
            } : undefined}
        />
        <CommonModal
            modalOpen={showAddContainer}
            setModalOpen={setShowAddContainer}
            pageHeader={'Storytelling toevoegen'}
            hideConfirm={true}
            content={
                <>
                    <div
                        className="add-options-container-item-container" {...clickableRowProps(() => {
                            setShowAddContainer(false);
                            setOpenModal(prevState => !prevState);
                            setAddType('media');
                        })}
                    >
                        <img src={plusButton} alt="" />
                        <p>Media (foto of video) toevoegen</p>
                    </div>
                    <div
                        className="add-options-container-item-container" {...clickableRowProps(() => {
                            setShowAddContainer(false);
                            setOpenModal(prevState => !prevState);
                            setAddType('quote');
                        })}
                    >
                        <img src={plusButton} alt="" />
                        <p>Quote toevoegen</p>
                    </div>
                    <div
                        className="add-options-container-item-container" {...clickableRowProps(() => {
                            setShowAddContainer(false);
                            setOpenModal(prevState => !prevState);
                            setAddType('anecdote');
                        })}
                    >
                        <img src={plusButton} alt="" />
                        <p>Anekdote toevoegen</p>
                    </div>
                </>
            }
        />
        <Modal
        isOpen={openModal}
        onRequestClose={openModal}
        style={modalStyles}
        contentLabel="Storytelling toevoegen"
        >
            <div>
                <h1>Selecteer {addingType()}</h1>
                <div>

                    {/* Media */}
                    {addType === 'media' && (
                        <div>
                            {allMedia && allMedia.map(item => (
                                <div className='select-storytelling-item-container'>
                                    <input 
                                    type="checkbox" 
                                    data-media={item.Media}
                                    data-docid={item.docid}
                                    data-url={item.Media}
                                    defaultChecked={item.ID === media && media.filter(mediaItem => mediaItem.Media.includes(item.ID))} 
                                    onChange={selectMediaItems}
                                    />
                                    <img src={item.Media} alt="" style={{width: '100px'}}/>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Quote */}
                    {addType === 'quote' && (
                        <div>
                            {allQuotes && allQuotes.map(item => (
                                <div className='select-storytelling-item-container'>
                                    <input 
                                    type="checkbox" 
                                    data-quote={item.Quote}
                                    data-docid={item.docid}
                                    defaultChecked={item.ID === quotes && quotes.filter(quoteItem => quoteItem.ID.includes(item.ID))} 
                                    onChange={selectMediaItems}
                                    />
                                    <p>{item.Quote}</p>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Anecdote */}
                    {addType === 'anecdote' && (
                        <div>
                            {allAnecdotes && allAnecdotes.map(item => (
                                <div className='select-storytelling-item-container'>
                                    <input 
                                    type="checkbox" 
                                    data-anecdote={item.Anecdote}
                                    data-docid={item.docid}
                                    defaultChecked={item.ID === anecdotes && anecdotes.filter(anecdoteItem => anecdoteItem.ID.includes(item.ID))} 
                                    onChange={selectMediaItems}
                                    />
                                    <p>{item.Anecdote}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    
                </div>
                <div id='delete-modal-button-container'>
                    <button id='modal-cancel-button'onClick={() => setOpenModal(false)}>Annuleren</button>
                    <button id='modal-save-button' onClick={addStorytelling}>Opslaan</button>
                </div>
            </div>
        </Modal>
        <DeleteModal
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          deleteItem={deleteStorytelling}
          deleteName={'dit onderdeel'}
          softDelete
        />
        </div>
      )}
    </ReadOnlyGuard>
  )
}

export default LiveReportMedia
